exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-information__order-comments[data-v-c6217ad6] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.order-information__sku-table[data-v-c6217ad6] {\n  margin-top: 20px;\n}\n.fixsizes[data-v-c6217ad6] {\n  word-break: break-all;\n}\n", ""]);

// exports
